import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import "./footer.css";

import Logo from "../../assets/images/logo.png";
import Marcador from "../../assets/images/marcador-branco.png";
import Email from "../../assets/images/email-branco.png";
import Whatsapp from "../../assets/images/whatsapp-branco.png";

function Footer() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="container-fluid footer-personalizado mt-5">
      <div className="footer-wrapper">
        <div className="row g-4 justify-content-between">
          {/* Coluna 1: Marca & Apresentação */}
          <div className="col-12 col-md-6 col-lg-4" data-aos="fade-up">
            <Link
              to="/"
              className="d-inline-flex flex-column align-items-start mb-3 text-decoration-none"
            >
              <img
                src={Logo}
                alt="Logo Antonio Saldanha Advocacia"
                className="footer-logo"
              />
            </Link>
            <p className="text-white-50 font-sm pe-lg-3">
              Direito com empatia, integridade e valores. Respeitar você é o
              primeiro passo.
            </p>
            <p className="text-white-50 font-xs">
              Atuação jurídica pautada pela ética, transparência e busca
              contínua por resultados em todo o Brasil.
            </p>
          </div>

          {/* Coluna 2: Navegação Institucional */}
          <div
            className="col-6 col-md-3 col-lg-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h3 className="fs-6 text-dourado text-uppercase fw-bold mb-3">
              Navegação
            </h3>
            <ul className="list-unstyled footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/sobre-nos">Sobre Nós</Link>
              </li>
              <li>
                <Link to="/o-escritorio">O Escritório</Link>
              </li>
              <li>
                <Link to="/nossa-equipe">Nossa Equipe</Link>
              </li>
              <li>
                <Link to="/#areas">Áreas de Atuação</Link>
              </li>
              <li>
                <Link to="/#contato">Fale Conosco</Link>
              </li>
              <li>
                <Link to="/politica-de-privacidade">
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>

          {/* Coluna 3: Áreas de Atuação */}
          <div
            className="col-6 col-md-3 col-lg-3"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h3 className="fs-6 text-dourado text-uppercase fw-bold mb-3">
              Áreas de Atuação
            </h3>
            <ul className="list-unstyled footer-links">
              <li>
                <Link to="/#areas">Direito Trabalhista</Link>
              </li>
              <li>
                <Link to="/#areas">Direito Penal</Link>
              </li>
              <li>
                <Link to="/#areas">Direito Previdenciário</Link>
              </li>
              <li>
                <Link to="/#areas">Direito Cível</Link>
              </li>
              <li>
                <Link to="/#areas">Direito Empresarial</Link>
              </li>
              <li>
                <Link to="/#areas">Direito de Família</Link>
              </li>
            </ul>
          </div>

          {/* Coluna 4: Contato & Endereço NAP */}
          <div
            className="col-12 col-md-6 col-lg-3"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h3 className="fs-6 text-dourado text-uppercase fw-bold mb-3">
              Contato
            </h3>

            <div className="footer-info-item mb-2">
              <img
                src={Marcador}
                alt="Ícone de Localização"
                width="18"
                height="18"
              />
              <p className="text-white mb-0 font-xs">
                R. Manuel Borba, 257 - Conj. 35 - Santo Amaro, São Paulo - SP
              </p>
            </div>

            <div className="footer-info-item mb-2">
              <img src={Email} alt="Ícone de E-mail" width="18" height="18" />
              <a
                href="mailto:saldanha.advocacia01@gmail.com"
                className="text-white text-decoration-none font-xs"
              >
                saldanha.advocacia01@gmail.com
              </a>
            </div>

            <div className="footer-info-item mb-3">
              <img
                src={Whatsapp}
                alt="Ícone de WhatsApp"
                width="18"
                height="18"
              />
              <a
                href="https://wa.me/5511954242066"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-decoration-none font-xs fw-semibold"
              >
                +55 (11) 95424-2066
              </a>
            </div>

            <button
              onClick={scrollToTop}
              className="btn btn-sm btn-outline-light rounded-1 mt-2 d-inline-flex align-items-center gap-1 font-xs"
            >
              <span>Voltar ao topo</span>
              <svg
                width="12"
                height="12"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 15l7-7 7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="footer-copyright mt-4 pt-3 border-top border-secondary text-center">
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 max-w-1200 mx-auto">
          <p className="mb-0 text-white-50 font-xs">
            © {new Date().getFullYear()} Antonio Saldanha Advocacia. Todos os
            direitos reservados.
          </p>
          <p className="mb-0 text-white-50 font-xs">
            <Link
              to="/politica-de-privacidade"
              className="text-white-50 text-decoration-underline me-3"
            >
              Política de Privacidade
            </Link>
            <span>Site Institucional Otimizado</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
